import React, { Component } from 'react';
import {InputGroup,Button,Input,InputGroupAddon,Modal,ModalBody} from 'reactstrap';
import Select from 'react-select';
import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';
import replace from 'lodash/replace';
import differenceBy from 'lodash/differenceBy';
import reverse from 'lodash/reverse';
import {deepClone} from './../../utils/copyObject';
import axios from './../../axios';
import * as url from './../../utils/url';
import findIndex from 'lodash/findIndex';
import OfficeCreatedIcon from './../../assets/office_created_icon.svg'
import InviteAdminModal from './../../components/OrganizationSetup/OrgChart/InviteAdminModal';
import EmptyTable from './../../components/EmptyTable/EmptyTable';
import InvitedAdminModal from './../../components/OrganizationSetup/OrgChart/InvitedAdminModal';

class ManageOffices extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      selectedOffice : {
        invitedAdmins : []
      },
      modalUsers : [],
      modalDataUpdated : false,
      showInvitationModal : false,
      showInvitedAdminModal : false,
      memberInputCount : 3
    }
  }

  applySearchSort = () => {
    const {searchedTerm,allOfficesWithInvitations,sortType} = this.props;
    let returnList = allOfficesWithInvitations;
    // console.log(sortType);
    if(sortType === 'a-z') {
      returnList = sortBy(allOfficesWithInvitations,(office) => office.officeName);
    } else if(sortType === 'z-a') {
      returnList = reverse(sortBy(allOfficesWithInvitations,(office) => office.officeName));
    } else if(sortType === 'invites-descending' 
      && filter(allOfficesWithInvitations,(office) => office.invitedAdmins && office.invitedAdmins.length > 0).length > 0) {
      returnList = reverse(sortBy(allOfficesWithInvitations,(office) => office.invitedAdmins.length));
    } else if(sortType === 'invites-ascending' &&
      filter(allOfficesWithInvitations,(office) => office.invitedAdmins).length > 0) {
      returnList = sortBy(allOfficesWithInvitations,(office) => office.invitedAdmins.length);
    }
    // console.log('sorting..');
    // console.log(returnList);
    if(searchedTerm.length === 0) {
      return returnList;
    }
    returnList = filter(returnList,(office) => 
      office.officeName.toLowerCase().contains(searchedTerm.toLowerCase()));
    return returnList;
  }

  handleInviteComplete = () => {
    const {modalUsers,selectedOffice} = this.state;
    // console.log(selectedOffice)
    let specialChar = /[~`!#$%\^&*+=\\[\]\\';,/{}|\\":<>\?0-9]/g
    let specialCount=0
    console.log("invite users")
    const inviteeArr = modalUsers.map((user) => {
      let name = user.firstName+user.lastName
      if(specialChar.test(name)){
        specialCount+=1
      }
      return omitBy({
        email : user.email,
        firstName : user.firstName,
        lastName : user.lastName
      },isUndefined);
    });
    const payload = [{
      inviteeArr : inviteeArr,
      officeHierarchyPath : selectedOffice.officeHierarchyPath,
      officeKey: selectedOffice.officeKey,
      officeName:selectedOffice.officeName
    }]
    console.log(payload);

    // return 

    if (specialCount>0) {
      this.setState({
        modalError : true,
        errorMessage :  "First and Last Name cannot contain numbers or any special characters."
      });
      return
    } else {
      axios.post(url.inviteAdminsForOffices,{data: payload}).then(({data}) => {
        const inviteesServer = data.data[selectedOffice.officeHierarchyPath];
        this.setState((p)=>({showInvitationModal : !p.showInvitationModal,modalUsers : [],modalError:false,errorMessage:''}));
        this.props.onInvitationComplete(selectedOffice.officeHierarchyPath,inviteesServer);
      }).catch(({response}) => {
        // console.log(response);
        // console.log(response.data.errors.message);
        let existingId; 
        if(response && response.data){
          if(response && response.data && response.data.errors &&response.data.errors && response.data.errors.error && response.data.errors.error.indexOf(',') >-1){
            existingId= response.data.errors.error.join(",");
          } else {
            existingId=response.data.errors.error
          }
        } 
        
       
        this.setState({
          modalError : true,
          errorMessage : existingId + ` ` + "is already registered or is not a valid email address. Please try a different one."
        });
      })
    }
   
  }

  handleInviteClick = (office) => {
    this.setState({
      selectedOffice : office,
      showInvitationModal : true
    });
  }

  showInvitedAdmins = (office) => {
    const originalInvitedAdmins = deepClone(office.invitedAdmins);
    this.setState({
      selectedOffice : office,
      originalInvitedAdmins : originalInvitedAdmins,
      showInvitedAdminModal : true,
      modalDataUpdated : false
    });
  }

  handleCancelInvitation = (user,officePath) => {
    const {selectedOffice} = this.state;
    const {invitedAdmins} = selectedOffice;
    const j = findIndex(invitedAdmins,{_id : user._id});
    const admin = invitedAdmins[j];
    invitedAdmins.splice(j,1, {...admin, removed : true});
    this.setState({
      selectedOffice : selectedOffice,
      modalDataUpdated : true
    });
    // axios.delete(url.removeOfficeMate + user._id).then(({data}) => {
    //   this.handleInvitedModalToggle();
    //   this.props.onRemoveUserComplete(officePath,user._id);
    // });
  }
 
  handleInputChange = (i,{name,value}) => {
    const {modalUsers} = this.state;
    const cloneUsers = deepClone(modalUsers);
    let index = findIndex(cloneUsers,{key : i});
    if(index > -1) {
      cloneUsers[index][name] = value;
    } else {
      cloneUsers.push({key : i,[name]:value});
    }
    this.setState({modalUsers : cloneUsers});
  }

  handleAddMember = () => {
    this.setState((p) => ({memberInputCount : p.memberInputCount + 1}));
  }

  handleInvitationModalToggle = () => {this.setState((p)=>({showInvitationModal : !p.showInvitationModal,modalUsers : [],modalError:false,memberInputCount:3}))}
  handleInvitedModalToggle = (type) => {
    if(type === '_SAVE_') {
      const {selectedOffice,originalInvitedAdmins} = this.state;
      // console.log(selectedOffice.invitedAdmins);
      // console.log(originalInvitedAdmins);
      const {invitedAdmins} = selectedOffice;
      // const diff = differenceBy(originalInvitedAdmins,invitedAdmins,'_id');
      const diff = invitedAdmins.filter((o) => o.removed);
      if(diff.length > 0) {

        const data = {
          emails: diff.map((o) => o.email),
        }
        axios.post(url.removeOfficeAdmins,data).then(({data}) => {
          this.handleInvitedModalToggle();
          this.props.onRemoveUserComplete(selectedOffice.officeHierarchyPath,diff.map((o) => o._id));
        })
      }
      //TODO REMOVE ADMINS FROM OFFICES.
    } else {
      const {selectedOffice,originalInvitedAdmins} = this.state;
      selectedOffice.invitedAdmins = originalInvitedAdmins;
      this.setState((p)=>({showInvitedAdminModal : !p.showInvitedAdminModal,
        modalUsers : [],modalError:false,
        memberInputCount:3,modalDataUpdated : false,selectedOffice : selectedOffice}));
    }
  }

  render() { 
    const {allOfficesWithInvitations,searchedTerm,sortType,userEmail} = this.props;
    const {selectedOffice,showInvitationModal,showInvitedAdminModal,
      modalError,errorMessage,memberInputCount,modalDataUpdated} = this.state;
      
    const list = this.applySearchSort(allOfficesWithInvitations);
    console.log(selectedOffice )
    return ( 
      <div className="mt40">
        <div className="row p-0 m-0">
          <div className="col-md-8 col-lg-8">
            <InputGroup  style={{height:'40px'}}>
              <Input 
                className="toolkit-field" 
                placeholder="Search by office name" 
                onChange={({target}) => this.props.onSearchQueryChange(target)}/>
              <InputGroupAddon addonType="append">
                <Button className="color-DADADA border-color-C3C4C7" style={{height:'40px'}}>
                  <i style={{color:'#A5A6AC',padding:'9px 18px'}} className="flaticon-search"></i>
                </Button>
              </InputGroupAddon>
            </InputGroup>
          </div>
          <div className="col-md-4 col-lg-4">
            <Select
              clearable={false}
              searchable={false}
              value={sortType}
              simpleValue
              options={[{value : 'a-z',label:'Name A-Z'},
              {value : 'z-a',label:'Name Z-A'},
              {value : 'invites-descending',label:'Number of Invites (descending)'},
              {value : 'invites-ascending',label:'Number of Invites (ascending)'}]
              }
              onChange={this.props.onSortChanged}
            />
          </div>
        </div>
        <div className="table-responsive-sm invite-office-admins-table" 
          style={{ marginTop:'10px'}}>
          <table className="table text-primary-color tool-list-font" 
            style={{borderTop:'0px'}}>
              <thead className='bottom-border-color'>
                <tr className="font-weight-bold text-secondary">
                  <th className="border-none data-mapping-table-header">
                    Office Name ({list.length})
                  </th>
                </tr>
              </thead>
            <tbody>
              <div style={{maxHeight:'400px',overflowY:'auto'}}>
              {
                list.length > 0 ? 
                list.map((office) => {
                  return(
                    <tr key={office.officeHierarchyPath}>
                      <td style={{width:'70%'}}>
                        <div>
                          {office.officeName}
                        </div>
                        {/* <div style={{fontSize:'12px'}}>
                          {replace(office.officeHierarchyPath,/#/g,' > ')}
                        </div> */}
                      </td>
                      <td className="alert-icon-bg text-right" style={{width:'25%'}}>
                      {
                        office.invitedAdmins&& office.invitedAdmins.length > 0 ? 
                        <span style={{color:'#54555A',cursor:'pointer'}} onClick={() => {this.showInvitedAdmins(office)}}>
                          <img style={{width:'25px',marginRight:'8px'}} src={OfficeCreatedIcon}/>
                          Office created
                        </span> :
                        <span>(no admins invited)</span> 
                      }
                      </td>
                      <td className="color-5099DE text-right cursor-pointer" 
                        onClick={() => {this.handleInviteClick(office)}} style={{width:'15%'}}>
                        Invite Admins
                      </td>
                    </tr>
                  )
                }) : 
                <tr>
                  <td>
                    <EmptyTable title="No results found" subtitle="Try rephrasing your search or changing your filters"/>
                  </td>
                </tr>
              }
              </div>
            </tbody>
          </table>
        </div>
        <Modal 
          isOpen={showInvitedAdminModal} 
          className="drill-down-modal">
          <ModalBody style={{padding:'30px 85px'}}>
            <InvitedAdminModal
              removeAdminCta
              invitedAdmins={selectedOffice.invitedAdmins}
              selectedOffice={selectedOffice}
              toggle={this.handleInvitedModalToggle}
              onCloseModal={this.handleCloseModal}
              onCancelInvitation={this.handleCancelInvitation}
              modalDataUpdated={modalDataUpdated}
              userEmail={userEmail}
            />
          </ModalBody>
        </Modal>
        <Modal 
          isOpen={showInvitationModal} 
          className="drill-down-modal">
          <ModalBody style={{padding:'30px 85px'}}>
            <InviteAdminModal
              onInputChange={this.handleInputChange}
              onAddMember={this.handleAddMember}
              onInviteComplete={this.handleInviteComplete}
              toggle={this.handleInvitationModalToggle}
              initialInputCount={memberInputCount}
              selectedOfficeName={selectedOffice.officeName}
              modalError={modalError}
              errorMessage={errorMessage}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
 
export default ManageOffices;